var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"d-flex",class:_vm.darkMode ? '' : 'la-creme'},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"10","lg":"6"}},[_c('GoogleLogin')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }